export default __webpack_public_path__ + "elevation-500-af496ebe387e1b4b36e4ed1199747198.png";